// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3MheM","overflowing":"ReadFullNote_overflowing__1sg-J"};